module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-social-media-slide-2.faf09c33.jpg";